import cn from "classnames";
import React from "react";

export default function ToggleWithNds(props) {
    const { value, filterData } = props;
    return (
        <div
            data-test-id="toggle-with-nds"
            className="mb-md-0 report__filters--mr col-form-label-sm cursor-pointer"
            onClick={() => filterData({ name: "overallReportWithNds", value: !value })}
        >
            <i className={cn("checkbox d-inline-block mr-1", { "checkbox--checked": !value })} />
            Без НДС
        </div>
    );
}
